import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { Grid } from "@mui/material";
import TextInput from "../../../reusableComponents/components/generics/TextInput";
import Dropdown from "../../../reusableComponents/components/generics/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  createContractDetails,
  createPolicyHolderInsuree,
  fetchPolicyholderInsureePicker,
  updateContractDetails,
} from "../../../action";
import InsureePicker from "../../../pickers/InsureePicker";
import { getPolicyholderId } from "../../../utils/helper";
import ContributionPlanPicker from "../../../pickers/ContributionPlanPicker";

const UpdateContractDialog = ({
  showDialog,
  setShowDialog,
  contractId,
  setShowUpdateDialog,
  showUpdateDialog,
  rowDataForEdit,
}) => {
  const SignInSuccess = useSelector((state) => state);
  const dispatch = useDispatch();
  const [policyHolderId, setPolicyHolderId] = useState();
  const [pickerPolicyHolderInsurees, setPickerPolicyHolderInsurees] =
    useState();
  const { t } = useTranslation();
  useEffect(() => {
    if (SignInSuccess?.profileReducer?.policyholderUserResponseData) {
      setPolicyHolderId(
        SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0]
          .policyHolder
      );
    }
    if (getPolicyholderId) {
      dispatch(fetchPolicyholderInsureePicker(getPolicyholderId));
    }
  }, [
    getPolicyholderId,
    SignInSuccess?.profileReducer?.policyholderUserResponseData,
  ]);

  useEffect(() => {
    setPickerPolicyHolderInsurees(
      SignInSuccess?.profileReducer?.pickerPolicyHolderInsurees
    );
  }, [SignInSuccess?.profileReducer?.pickerPolicyHolderInsurees]);
  const handleClose = () => {
    setShowUpdateDialog(false);
  };
  const onSubmit = async (values) => {
    const value = {
      values,
      contributionPlanBundle:
        pickerPolicyHolderInsurees?.[0]?.contributionPlanBundle,
      contractId: contractId,
      jsonExt: { calculation_rule: { income: values.income, rate: 0 } },
      contract: rowDataForEdit,
    };
    dispatch(updateContractDetails(value));
    if (SignInSuccess?.profileReducer?.mutations?.[0]?.error == null) {
      handleClose();
    }
  };
  let options = !!pickerPolicyHolderInsurees
    ? [
        ...pickerPolicyHolderInsurees.map((v) => ({
          value: v.insuree,
          label: `${v.insuree.lastName} ${v.insuree.otherNames}`,
        })),
      ]
    : [];

  return (
    <React.Fragment>
      <Dialog open={showUpdateDialog}>
        <DialogTitle>{t("Edit Insuree Details")}</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item>
              <Grid container>
                <Form
                  onSubmit={onSubmit}
                  initialValues={{
                    insuree:
                      rowDataForEdit?.insuree &&
                      `${rowDataForEdit.insuree.lastName} ${rowDataForEdit.insuree.otherNames}`,
                    income: rowDataForEdit?.jsonExt
                      ? JSON.parse(rowDataForEdit.jsonExt).calculation_rule
                          ?.income
                      : "",
                  }}
                  render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                    errors,
                  }) => {
                    return (
                      // setFormValues(values),
                      <form onSubmit={handleSubmit}>
                        <Grid container>
                          <Grid item xs={12} className="common-input">
                         { rowDataForEdit?.insuree ?
                            <Field
                              name="insuree"
                              component={TextInput}
                              label={t("Insuree Name")}
                              required
                              options={options}
                              type="text"
                              disabled={true}
                            />:
                            <Field
                              name="insuree"
                              component={Dropdown}
                              label={t("Insuree Name")}
                              required
                              options={options}
                              type="text"
                            />}
                          </Grid>
                          {/* <Grid item xs={12} className="common-input">
                          <Field
                            name="contributionPlan"
                            component={ContributionPlanPicker}
                            label="Contribution Plan Bundle"
                            // type="text"
                          />
                        </Grid> */}
                          <Grid item xs={12} className="common-input">
                            <Field
                              name="income"
                              component={TextInput}
                              label="Income"
                              type="text"
                            />
                          </Grid>
                        </Grid>
                        <DialogActions>
                          <Button onClick={handleClose}>Cancel</Button>

                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            size="large"
                            disabled={submitting || pristine}
                            // style={{ width: "100%" }}
                            // fullWidth
                          >
                            Save
                          </Button>
                        </DialogActions>
                      </form>
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
export default UpdateContractDialog;
